import {Injectable} from '@angular/core';
import {ConfirmationComponent} from '../confirmation/confirmation.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root'
})
export class AppService {

    constructor(private modalService: NgbModal) {
    }

    openConfirmationModal(callback: any, title, description) {
        const t = this;
        const modal = this.modalService.open(ConfirmationComponent, {
            keyboard: false,
            windowClass: 'tvm-centered',
            backdrop: 'static',
        });
        modal.componentInstance.title = title;
        modal.componentInstance.description = description;

        modal.result.then((data: any) => {
            callback();
            console.log('ok');
        });
    }


}
